import React, { useEffect, useState, useMemo } from 'react';
import { Link } from "react-router-dom";
import classnames from "classnames";
import Address from './Address';
import { useQueryClient } from '@tanstack/react-query';
import TableContainer1 from "../../Components/Common/DataTables/TableContainer1";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Collapse,
  Nav, NavItem, NavLink, TabContent, TabPane
} from "reactstrap";
import useOrder from '../../hooks/useOrder';
import { formatdate_DMY } from "../../utils/formatdate_DMY.js"
import { useSelector, useDispatch } from 'react-redux';
import { setorderNextstep } from '../../slices/orderslice';
import OrderStatusbar from "./OrderStatusbar";
import useMaster from "../../hooks/useMaster";
import BottomTabs from "./BottomTabs"
import ErrorBoundary from "../../Components/Common/ErrorBoundary";
import OrderCancel from './OrderCancel.js';
import Loader2 from '../../Components/Common/Loader2';
const OrderModal = ({ closeModal, closeordermodal }) => {
  const dispatch = useDispatch()
  const { getAllCountries } = useMaster();
  const orderNextstep = useSelector(state => state.orderslice.orderNextstep);
  const vieworderbyid = useSelector(state => state.orderslice.vieworderbyid);

  const { postOrderbyid, updateStatus, getOrderList, cancleOrderapi, getGatewayPaymentListapi } = useOrder();

  const queryClient = useQueryClient();

  const { isLoading, data, refetch } = postOrderbyid(vieworderbyid)


  useEffect(() => {
    const queryKey = ['OrderbyidApi', { id: vieworderbyid }];
    const cachedData = queryClient.getQueryData(queryKey);

    if (cachedData) {
      queryClient.removeQueries(queryKey, { exact: true });
    }
  }, [queryClient, vieworderbyid]);

  const { isLoading: isLoadingCountry, data: countryData } = getAllCountries();

  const countryList = countryData?.data?.result || [];

  const currentCountry = useMemo(() => {
    return countryList.find(c => c.country_id === data?.data[0]?.country_id) || {};
  }, [data?.data[0]?.country_id]);

  const countryCurrency = currentCountry?.currency || "";
  const { isLoading: isLoadingGatewayPayment, data: GatewayPaymentListData } = getGatewayPaymentListapi();

  const gatename = GatewayPaymentListData?.data.filter(
    (ele) => ele.id == data?.data[0].gway_paymentmethod
  );

  const masterdata = useSelector((state) => state.globalslice.masterdata || []);
  const payment_methoddata = useMemo(() => (
    (masterdata || [])
      .filter(ele => ele.list_type === 'payment_method')
      .map(item => ({ label: item.list_lable, value: item.list_value }))
  ), [masterdata]);
  const order_fromdata = useMemo(() => (
    (masterdata || [])
      .filter(ele => ele.list_type === 'order_from')
      .map(item => ({ label: item.list_lable, value: item.list_value }))
  ), [masterdata]);

  const statusStepss = [
    { label: "To be Processed" },
    { label: "To be Packed" },
    { label: "To be OFD" },
    { label: "To be Delivered" },

    { label: " Delivered" }
  ];

  const columns = useMemo(() => [
    {
      header: "Products",
      accessorKey: "title",
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => {
        const product = row.original;
        return (
          <div
            className="order-products"
            style={{ color: product.inventory === 0 ? "red" : "inherit" }}
          >
            ({product.product_sku}) {product.title}
          </div>
        );
      },
    },


    {
      header: "Stock",
      accessorKey: "inventory",
      enableSorting: true,
      enableColumnFilter: false,
    },
    {
      header: "Items",
      accessorKey: "quantity",
      enableSorting: true,
      enableColumnFilter: false,

    },
    {
      header: "Amount",
      accessorKey: "selling_price",
      enableSorting: true,
      enableColumnFilter: false,
    },



  ], []);


  return (
    <>
      <ErrorBoundary fallback={<div>Oops! Something went wrong loading the page.</div>}>
        <Container fluid className='order-modal-main'>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className="mb-0" style={{ color: '#003049' }}>Order Detail</h5>
            <i
              className="ri-close-line"
              style={{ fontSize: '24px', cursor: 'pointer', color: '#003049' }}
              title="Close"
              onClick={() => {
                closeModal();
                closeordermodal();
                dispatch(setorderNextstep(false))
              }}

            ></i>
          </div>
          {
            isLoading ?
              <Loader2 />
              :
              <div className='ordermodal-data'>
                <Row>
                  <Col lg={4}>

                    <Card style={{
                      height: "85%"
                    }}>

                      <h6 className="card-title mb-0 ps-2">
                        {" "}
                        Order Details
                      </h6>

                      <CardBody>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Order ID:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">#{data?.data?.[0]?.orderid}</h6>
                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Order RefID:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">#{data?.data?.[0]?.order_ref_code}</h6>
                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Order Date:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            {formatdate_DMY(data?.data?.[0]?.order_date, "DD-MM-YYYY HH:mm")}

                          </div>
                        </div>

                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Order From:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            {order_fromdata.find(item => item.value == data?.data?.[0].channel)?.label}

                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Dispatch Date:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            {formatdate_DMY(data?.data?.[0]?.despatch_date, "DD-MM-YYYY HH:mm")}

                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Driver Details:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            {data?.data?.[0]?.delivery_detail}

                          </div>
                        </div>

                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4}>

                    <Card style={{
                      height: "85%"
                    }}>

                      <h6 className="card-title mb-0 ps-2">
                        {" "}
                        Payment Details
                      </h6>

                      <CardBody>

                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Payment Method:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0"> {payment_methoddata.find(item => item.value == data?.data?.[0].payment_methodid)?.label}</h6>
                          </div>
                        </div>

                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Total Amount:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{countryCurrency}{" "}{data?.data?.[0].total_amount}</h6>
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Gateway:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{gatename?.[0]?.name ?? ""}</h6>

                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Fort Id:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{data?.data?.[0].gway_transaction_id}</h6>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col lg={4}>

                    <Card style={{
                      height: "85%"
                    }}>

                      <h6 className="card-title mb-0 ps-2">

                        Customer Details
                      </h6>

                      <CardBody>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Name:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.first_name}</h6>
                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Mobile:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.mobile}</h6>
                          </div>
                        </div>
                        <div className="d-flex align-items-center ">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0">Email:</p>
                          </div>
                          <div className="flex-grow-1 ms-2">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.email}</h6>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0 me-2">Building Name:</p>
                          </div>
                          <div className="flex-grow-1 ">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.building_name}</h6>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0 me-2">Address:</p>
                          </div>
                          <div className="flex-grow-1 ">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.address},{data?.data?.[0]?.customer_details?.emirate_name},{data?.data?.[0]?.customer_details?.area_name}</h6>
                          </div>
                        </div>
                        <div className="d-flex">
                          <div className="flex-shrink-0">
                            <p className="text-muted mb-0 me-2">Emirate/Area:</p>
                          </div>
                          <div className="flex-grow-1 ">
                            <h6 className="mb-0">{data?.data?.[0]?.customer_details?.emirate_name},{data?.data?.[0]?.customer_details?.area_name}</h6>
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                <Row>
                  <Col xl={12}>
                    <Card>
                      <h5 className='ps-4'>Order Status</h5>
                      <div className='m-5'>
                        <OrderStatusbar statuses={statusStepss} currentStep={data?.data?.[0]?.order_statusid} />
                      </div>
                      <TableContainer1
                        columns={columns || []}
                        data={!isLoading ? data?.data?.[0]?.product_details || [] : []}
                        customPageSize={process.env.REACT_APP_PER_PAGE}
                        total={0}
                        disableSearch={true}
                        disableNavigation={true}
                        SearchPlaceholder='Search...'
                      />
                      <Row>
                        <Col lg={6}>

                        </Col>
                        <Col lg={6}>
                          <table className="table table-sm table-borderless mb-0">
                            <tbody>
                              <tr>
                                <td>Sub Total :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].sub_total - data?.data?.[0].tax_amount}</td>
                              </tr>
                              <tr>
                                <td>
                                  Shipping charges
                                  :
                                </td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].shipping_charges}</td>
                              </tr>
                              <tr>
                                <td>Processing fee :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].processing_fee}</td>
                              </tr>
                              <tr>
                                <td>Balance Amount :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].balance_amount}</td>
                              </tr>

                              <tr>
                                <td>Discount Amount :</td>
                                <td className="text-end">-{countryCurrency}{" "}{data?.data?.[0].discount_amount}</td>
                              </tr>
                              <tr>
                                <td>Credit Amount :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].credit_amount}</td>
                              </tr>
                              <tr>
                                <td>Donation :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].donation_fee}</td>
                              </tr>
                              <tr>
                                <td>Tax :</td>
                                <td className="text-end">{countryCurrency}{" "}{data?.data?.[0].tax_amount}</td>
                              </tr>
                              <tr className="border-top border-top-dashed">
                                <th scope="row">Total :</th>
                                <th className="text-end">{countryCurrency}{" "}{data?.data?.[0].total_amount}</th>
                              </tr>
                            </tbody>
                          </table></Col>
                        <Col lg={6}>

                        </Col>
                        <Col lg={6}>
                          {
                            orderNextstep &&
                            <OrderCancel orderstatus={data?.data?.[0]?.order_statusid} orderid={data?.data?.[0]?.orderid} closeModal={closeModal} />
                          }
                        </Col>
                      </Row>

                    </Card>

                    <BottomTabs previousorderdata={data} previousticketsdata={data?.data?.[0]} OrderHistorydata={data?.data?.[0]} cartid={data?.data?.[0]?.customer_details?.customer_id} />

                  </Col>


                </Row>
              </div>
          }


        </Container>
      </ErrorBoundary>
    </>
  );
};

// Main App component to render the OrderDetailMonitor
export default React.memo(OrderModal);
